// extracted by mini-css-extract-plugin
export default {"input":"FilterBTN_input__WoJFK","label":"FilterBTN_label__6tFyl"};